export interface DeleteSystemUserRequest {
  id: string
  revision: number
}

export function DeleteSystemUserRequestToJSON(
  value: DeleteSystemUserRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
